import { Box, Typography } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import Progress from '../../common/Progress'
import { formatVideoDuration, latexDelimiters } from '../../../utils/utilities'
import { useMeetingStore } from '../../../store/meeting.store'
import { observer } from 'mobx-react'
import Latex from 'react-latex-next'

const NextPollTimer = observer( ( { nextScheduledPoll, schedulerInterval } ) => {
    const [timeLeft, setTimeLeft] = useState( 0 )

    const MeetingStore = useMeetingStore()

    const totalDifference = useMemo( () => {
        if ( schedulerInterval )
            return schedulerInterval * 60
        return Math.max( 0, nextScheduledPoll - Date.now() ) / 1000
    }, [nextScheduledPoll, schedulerInterval] )

    useEffect( () => {
        if ( !nextScheduledPoll ) {
            setTimeLeft( 0 )
            return
        }

        // Update the countdown every 100ms for smoothness
        const interval = setInterval( () => {
            const now = Date.now()
            const difference = Math.max( 0, nextScheduledPoll - now )
            setTimeLeft( Math.ceil( difference / 1000 ) )
        }, 100 )

        return () => clearInterval( interval )
    }, [nextScheduledPoll] )

    if ( !nextScheduledPoll ) return <Typography variant='subtitle2' display="block" component="p">Scheduler is paused or poll queue is empty.</Typography>

    return (
        <Box overflow="hidden" display="flex" gap="10px" borderRadius="10px" alignItems="center" >
            <Progress showLabel labelStyles={{ fontSize: "12px", fontWeight: 500 }} trackWidth={8} indicatorWidth={8} size={60} label={formatVideoDuration( timeLeft )} progress={( timeLeft / totalDifference ) * 100} />
            <Box minWidth={0} flexGrow={1}>
                <Typography variant='subtitle2' display="block" fontSize="14px" fontWeight={600} component="p">Next poll</Typography>
                {MeetingStore.getPollQueue.at( 0 ) && <Typography variant='subtitle2' minWidth={0} fontSize="12px" noWrap display="block" fontWeight={400} sx={{ fontStyle: "italic" }} component="div"><Latex delimiters={latexDelimiters}>{MeetingStore.getPollQueue.at( 0 ).question}</Latex></Typography>}
            </Box>
        </Box>
    )
} )

export default NextPollTimer